export const isDownloadLoading = (state) => Object.values(state.isDownloadLoading).some((isLoading) => isLoading);

export const previewURL = (state) => state.previewURL;
